<!--TODO: check&compare isInline and isRadioInline (corner case in new role model)-->
<shared-ui-menu
  [isMobile]="isMobile()"
  [isInline]="isInline()"
  [isRadioInline]="isRadioInline()"
  [title]="title()"
  [height]="height()"
  [maxHeight]="maxHeight()"
  [closeAfterClick]="false"
  (dialogClose)="onDialogClose($event)"
  (dialogConfirm)="dialogConfirm.emit(value())"
  [isDisabled]="items()?.length === 0 || isDisabled()"
  [buttonClass]="buttonClass()"
  [dialogTitle]="dialogTitle()"
>
  <ng-container button>
    <ng-content select="[button]"></ng-content
  ></ng-container>

  <ng-container header>
    <ng-content select="[header]"></ng-content>
  </ng-container>

  @for (item of viewItems(); track item.title) {
    <div class="menu-item">
      <input
        class="radio-button"
        type="radio"
        [id]="item.title"
        [checked]="item.checked"
        (click)="onMenuItemTriggered(item)"
      />
      <label [for]="item.title">
        <span class="overflow-hidden overflow-ellipsis whitespace-nowrap">{{
          item.title || '—'
        }}</span>
      </label>
    </div>
  }

  <ng-container footer>
    <ng-content select="[footer]"></ng-content>
  </ng-container>
</shared-ui-menu>
